import React, { useEffect, useState, useRef } from 'react';
import '../Game.css';
import Title from '../../../Objects/Title/Title';
import List from '../../../Objects/List/List';
import CommonButton, { btnColors, btnSizes } from '../../../Objects/CommonButton/CommonButton';
import Input, { inputColors, inputSizes } from '../../../Objects/Input/Input';
import { getKey, pushValue, removePath, setValue } from '../../../firebase';
import { errcode, fullScreen, globalVars } from '../../../App';
import LoadingDialog from '../../../Objects/LoadingDialog/LoadingDialog';
import Dialog from '../../../Objects/Dialog/Dialog';
import { PopCheck, PopDivider, PopSlider, PopToggle, PopWell, PopX2 } from '../../../Objects/Dialog/PopParts';
import FlatIcon from '../../../Objects/Icona/FlatIcon';
import Icona from '../../../Objects/Icona/Icona';
import { firebaseCommands, listHasTeam } from '../Game';

//limiti di caratteri dei nomi
const GROUP_NAME_MAX = 13;
const WORD_MAX = 17;


const CreateTeams = ({listData, changeState, useStandards, setUseStandards, useCustoms, setUseCustoms, customWords, setCustomWords, percent, setPercent}) => {
    const [isCreating, create] = useState({
        step: 1,
        index: -1,
        next: 1
    });

    const [canConfirm, setCanConfirm] = useState(false);
    const [canStart, setCanStart] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [myTeams, setMyTeams] = useState([]);
    const [showMyTeams, setShowMyTeams] = useState(false);

    const [showCustomWords, setShowCustomWords] = useState(false);
    const [showGroup, setShowGroup] = useState(false);
    const [curGroup, setCurGroup] = useState(0);
    const [showAddGroup, setShowAddGroup] = useState(false);
    const [showAddWord, setShowAddWord] = useState(false);
    const [showDeleteGroup, setShowDeleteGroup] = useState(false);
    const [canConfirmGroup, setCanConfirmGroup] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const [isDouble, setIsDouble] = useState(false);
    const [groupNameLen, setGroupNameLen] = useState(0);
    const [newWord, setNewWord] = useState({ len: 0, spaced: false });
    const [addedNow, setAddedNow] = useState([]);   //parole aggiunte da quando è aperto il popup

    /* struttura custom words:
    [gruppo {
        name,
        parole [
            parola {
                name,
                isDouble,
                selected,
                enabled     vero se tra le custom words attive non è già presente
            },
        ],
        selected,
        enabled     vero solo se c'è almeno una parola al suo interno
    },]
    */

    const canConfirmRef = useRef(canConfirm);
    const canConfirmGroupRef = useRef(canConfirmGroup);
    const isDoubleRef = useRef(isDouble);
    
    useEffect(() => {
        canConfirmRef.current = canConfirm;
    }, [canConfirm])

    useEffect(() => {
        canConfirmGroupRef.current = canConfirmGroup;
    }, [canConfirmGroup])

    useEffect(() => {
        isDoubleRef.current = isDouble;
    }, [isDouble])

    useEffect(() => {
        //console.log("changed "+ isCreating.step);
        const steps = ["", "#create-team-view", "#create-team-create", "#create-team-edit", "#myTeams-dialog"]
        if(isCreating.step != isCreating.next) {
            let step1 = document.querySelector(steps[isCreating.step]);
            step1.classList.remove("fade-in");
            step1.classList.add("fade-out");
            setTimeout(() => {
                create(prevState => ({
                    ...prevState,
                    step: isCreating.next
                }));
            }, 300);
        }
        if(isCreating.step == isCreating.next) {
            //lastStep = isCreating.step;
            setTimeout(() => {
                let step2 = document.querySelector(steps[isCreating.step]);
                step2.style.opacity = null;
                step2.classList.add("fade-in");
            }, 10);
        }
    }, [isCreating])

    useEffect(() => {
        if(showMyTeams) {
            setTimeout(() => {
                let d = document.querySelector("#myTeams-dialog");
                d.style.opacity = null;
                d.classList.add("fade-in");
            }, 10);
        }
        
    }, [showMyTeams])

    useEffect(() => {
        if(showCustomWords) {
            setTimeout(() => {
                let d = document.querySelector("#customWords-dialog");
                d.style.opacity = null;
                d.classList.add("fade-in");
            }, 10);
        }
        
    }, [showCustomWords])

    useEffect(() => {
        if(showAddGroup) {
            setGroupNameLen(0);
            setTimeout(() => {
                let d = document.querySelector("#addGroup-dialog");
                d.style.opacity = null;
                d.classList.add("fade-in");
            }, 10);
        } else {
            setCanConfirmGroup(false);
        }
    }, [showAddGroup])
    
    useEffect(() => {
        if(showGroup) {
            setTimeout(() => {
                let d = document.querySelector("#wordGroup-dialog");
                d.style.opacity = null;
                d.classList.add("fade-in");
            }, 10);
        }
        
    }, [showGroup])

    useEffect(() => {
        if(showDeleteGroup) {
            setTimeout(() => {
                let d = document.querySelector("#deleteGroup-dialog");
                d.style.opacity = null;
                d.classList.add("fade-in");
            }, 10);
        }
    }, [showDeleteGroup])

    useEffect(() => {
        if(showAddWord) {
            setAddedNow([]);
            setNewWord({ len: 0, spaced: false });
            setTimeout(() => {
                let d = document.querySelector("#addWord-dialog");
                d.style.opacity = null;
                d.classList.add("fade-in");
            }, 10);
        } else {
            setCanConfirmGroup(false);
        }
    }, [showAddWord])

    useEffect(() => {
        if(!firstLoad) {
            let list = JSON.parse(JSON.stringify(customWords));;

            list.forEach(group => {
                group.words.forEach(word => {
                    delete word.selected;
                })
                delete group.selected;
                delete group.enabled;
            });

            //console.log(list);
            if(canUseCustoms()) {
                setUseCustoms(true);
            } else {
                setUseStandards(true);
            }
            setUseCustoms(canUseCustoms());
            localStorage.setItem("customWords", JSON.stringify(list));
        }
    }, [customWords])

    useEffect(() => {
        if(useStandards && useCustoms) {
            setPercent(0.7);
        } else {
            setPercent(useStandards ? 1 : 0);
        }
    }, [useStandards, useCustoms])

    useEffect(() => {
        if(error!="") {
            setTimeout(() => {
                let d = document.querySelector("#error");
                d.style.opacity = null;
                d.classList.add("fade-in");
            }, 10);
            
        }
    }, [error])

    useEffect(() => {
        //console.log(localStorage.getItem("customWords"));
        let t = JSON.parse(localStorage.getItem("myTeams"));
        let l = [];

        t.forEach(e => {
            l.push({
                name: e,
                enabled: true,
                selected: false
            })
        });
        setMyTeams(l);

        if(customWords.length == 0) {
            let a = JSON.parse(localStorage.getItem("customWords"));
            a.forEach(e => {
                e.words.forEach(ee => {
                    ee.selected = false;
                });
                e.selected = false;
                e.enabled = (e.words.length > 0)
            });
            setFirstLoad(false);
            setCustomWords(a);
        }
        
    }, [])
    
    if(listData.length > 0) {
        if(!canStart) {
            setCanStart(true);
        }
    } else {
        if(canStart) {
            setCanStart(false);
        }
    }

    const onInputChange = (event, charLimit, enable) => {
        let txt = event.target.value.trim();
        if(txt !="" && txt.length <= charLimit) {
            enable(true);
        } else {
            enable(false);
        }

        if(enable == setCanConfirmGroup) {
            if(txt.trim().split(" ").length > 1) {
                setIsDouble(true);
            } else {
                setIsDouble(false);
            }
        }
    }

    const closePopup = (id, hide) => {
        let d = document.getElementById(id);
        d.classList.remove("fade-in")
        d.style.opacity = null;
        d.classList.add("fade-out");

        setTimeout(() => {
            hide(false);
        }, 100);
    }

    /*
        GESTIONE CREAZIONE SQUADRE
    */
    const createTeam = async () => {
        if(canConfirmRef.current) {
            const name = document.getElementById("teamName").querySelector(".input").value.toUpperCase().trim();

            if(!listHasTeam(listData, name)) {
                //creazione nuova squadra
                const newTeam = {
                    name: name,
                    score: 0
                }
                listData.push(newTeam);
                //console.log(listData.elements);

                changeState(listData);

                setLoading(true);
                await setValue(globalVars.code+"/teams/", listData)
                .then(() => {
                    setLoading(false);
                    create(prevState => ({
                        ...prevState,
                        next: 1,
                    }));
                    setCanConfirm(false);
                }).catch((e) => {
                    setLoading(false);
                    setError(errcode["ERR_EDIT_TEAM"]);
                    //console.log(e);
                });
            } else {
                setError(errcode["ERR_DUPL_TEAM"]);
            }
        }
    }

    const editTeam = async () => {
        if(canConfirmRef.current) {
            const name = document.getElementById("teamName").querySelector(".input").value.toUpperCase().trim();

            if(!listHasTeam(listData, name) || listData.indexOf(name) == isCreating.index) {
                //modifica squadra
                //let key = await getKey(globalVars.code+"/teams", "name", listData.elements[isCreating.index]);
                
                listData[isCreating.index].name = name;
                changeState(listData);
                //console.log(listData.elements);
                setLoading(true);

                await setValue(globalVars.code+"/teams/", listData)
                .then(() => {
                    setLoading(false);
                    create(prevState => ({
                        ...prevState,
                        next: 1,
                    }));
                    setCanConfirm(false);
                }).catch((e) => {
                    setLoading(false);
                    setError(errcode["ERR_EDIT_TEAM"]);
                    //console.log(e);
                });
            } else {
                setError(errcode["ERR_DUPL_TEAM"]);
            }
        }
    }

    const deleteTeam = async () => {

        //elimina squadra
        //let key = await getKey(globalVars.code+"/teams", "name", listData.elements[isCreating.index]);
        
        listData.splice(isCreating.index, 1);

        changeState(listData);
        
        //console.log(listData.elements);
        setLoading(true);

        await setValue(globalVars.code+"/teams/", listData)
        .then(() => {
            setLoading(false);
            create(prevState => ({
                ...prevState,
                next: 1,
            }));
            setCanConfirm(false);
        }).catch((e) => {
            setLoading(false);
            setError(errcode["ERR_EDIT_TEAM"]);
            //console.log(e);
        });
    }

    const addGroup = () => {
        if(canConfirmGroupRef.current) {
            const name = document.getElementById("groupName").querySelector(".input").value.toUpperCase().trim();
            if(!listHasTeam(customWords, name)) {
                closePopup("addGroup-dialog", setShowAddGroup);

                let list = customWords.slice();
                list.push({
                    name,
                    selected: false,
                    enabled: false,
                    words: []
                })

                setCustomWords(list);
            } else {
                setError(errcode["ERR_DUPL_GROUP"]);
            }
        }
    }

    const addWord = (setCanConfirmGroup) => {
        let isDouble = isDoubleRef.current
        //console.log(curGroup, isDouble);
        if(canConfirmGroupRef.current) {
            const input = document.getElementById("newWord");
            const name = input.querySelector(".input").value.toUpperCase().trim();
            if(!listHasTeam(customWords[curGroup].words, name)) {
                //closePopup("addWord-dialog", setShowAddWord);
                setCanConfirmGroup(false);
                
                let list = customWords.slice();
                list[curGroup].words.push({
                    name,
                    isDouble,
                    selected: true
                })
                list[curGroup].enabled = true;
                list[curGroup].selected = isGroupSelected(list[curGroup]);

                /* if(isDouble) {
                    doubleWords.push(name);
                    setDoubleWords(doubleWords);
                } else {
                    words.push(name);
                    setWords(words);
                } */

                //aggiungi le custom words all'avvio della partita

                setCustomWords(list);
                setAddedNow(prev => [...prev, { name, isDouble }]);
                setNewWord({ len: 0, spaced: false });

                input.querySelector(".input").value = "";
                input.querySelector(".input").focus();
                input.querySelector(".input").placeholder = "Parola aggiunta!"

                //lampeggio verde di conferma
                let wt = 80;

                input.classList.toggle(inputColors.done);
                setTimeout(() => {
                    input.classList.toggle(inputColors.done);
                    setTimeout(() => {
                        input.classList.toggle(inputColors.done);
                        setTimeout(() => {
                            input.classList.toggle(inputColors.done);
                        }, wt);
                    }, wt);
                }, wt);
            } else {
                setError(errcode["ERR_DUPL_WORD"]);
            }
        }

        setIsDouble(false);
    }

    const isGroupSelected = (group) => {
        if(group.words.length > 0) {
            let full = true;
            let indt = false;
            group.words.forEach(e => {
                if(e.selected) {
                    indt = true;
                }
                if(!e.selected) {
                    full = false;
                }
            });
            if(full) {
                return true;
            }
            if(indt) {
                return "indt";
            }
        }
        return false;
    }

    const canUseCustoms = () => {
        return customWords.some(group => 
            group.words.some(word => word.selected)
        );
    }

    //quota di parole standard (0..1, passo 0.1)
    const updateSliderVal = (sliderValue, _setValue) => {
        let value = parseFloat(sliderValue).toFixed(1);

        if(!useCustoms || !useStandards) {
            value = useStandards ? 1 : 0;
        }
        _setValue(value);

    }

    /*
        GESTIONE GRUPPI E PAROLE PERSONALIZZATE
    */
    const countSelected = (words) => words.filter(w => w.selected).length;
    const selectedWordsTotal = customWords.reduce((tot, group) => tot + countSelected(group.words), 0);
    const hasAnyWord = customWords.some(group => group.words.length > 0);
    const stdPerc = Math.round(parseFloat(percent) * 100);

    const toggleGroup = (index) => {
        //seleziona/deseleziona tutte le parole del gruppo
        let list = customWords.slice();
        list[index].selected = !list[index].selected;
        list[index].words.forEach(e => {
            e.selected = list[index].selected;
        });
        setCustomWords(list);
    }

    const openGroup = (index) => {
        closePopup("customWords-dialog", setShowCustomWords);
        setCurGroup(index);
        setShowGroup(true);
    }

    const backToGroups = () => {
        closePopup("wordGroup-dialog", setShowGroup);
        setShowCustomWords(true);
    }

    const deleteGroup = () => {
        //chiusura immediata: il popup del gruppo non deve più leggere il gruppo eliminato
        let list = customWords.slice();
        list.splice(curGroup, 1);
        setShowDeleteGroup(false);
        setShowGroup(false);
        setCurGroup(0);
        setCustomWords(list);
        setShowCustomWords(true);
    }

    const toggleWord = (index) => {
        let list = customWords.slice();
        list[curGroup].words[index].selected = !list[curGroup].words[index].selected;
        list[curGroup].selected = isGroupSelected(list[curGroup]);
        setCustomWords(list);
    }

    const deleteWord = (index) => {
        let list = customWords.slice();
        list[curGroup].words.splice(index, 1);
        list[curGroup].enabled = list[curGroup].words.length > 0
        list[curGroup].selected = isGroupSelected(list[curGroup]);
        setCustomWords(list);
    }

    const toggleAllWords = () => {
        //tutte selezionate -> nessuna, altrimenti tutte
        let list = customWords.slice();
        const group = list[curGroup];
        const all = group.words.length > 0 && group.words.every(w => w.selected);
        group.words.forEach(w => {
            w.selected = !all;
        });
        group.selected = isGroupSelected(group);
        setCustomWords(list);
    }

    return (
        <div className='createTeams'>
            {/* loading dialog */}
            {loading && <LoadingDialog id="creatingTeam" txt="Salvataggio..."/>}

            {/* error dialog */}
            {error && <Dialog
                id="error"
                title="Si è verificato un errore!"
                icon="warn"
                plate="fire"
                txt={error}
                common={() => {
                    closePopup("error", setError);
                }}
            />}


            {/* Visualizza squadre */}
            {isCreating.step==1 && <div className='createTeams' id="create-team-view" style={{opacity: 0}}>

                {/* GRUPPI DI PAROLE */}
                {showCustomWords && <Dialog
                    id="customWords-dialog"
                    title="Gruppi di parole"
                    subtitle={customWords.length > 0 ? "Spunta un gruppo per usarlo tutto, oppure aprilo per scegliere le singole parole." : undefined}
                    className="guide-shell"
                    common={() => {
                        closePopup("customWords-dialog", setShowCustomWords);
                    }}
                    actions={[{
                        id: "addGroup",
                        color: "green",
                        icon: "plus",
                        txt: "Crea gruppo",
                        onClick: () => setShowAddGroup(true),
                    }]}
                >
                    {customWords.length > 0 ? (
                        <PopWell scroll>
                            <div className='pop-head'>
                                <span className='pop-cap'>I tuoi gruppi</span>
                                <span className='pop-meta'><b>{selectedWordsTotal}</b> {selectedWordsTotal === 1 ? "parola selezionata" : "parole selezionate"}</span>
                            </div>
                            <div className='pop-rows'>
                                {customWords.map((group, index) => {
                                    const doubles = group.words.filter(w => w.isDouble).length;
                                    const rowState = !group.enabled ? "pop-row-empty" : group.selected ? "pop-row-on" : "pop-row-off";
                                    return (
                                        <div key={group.name} className={'pop-row ' + rowState} onClick={() => openGroup(index)}>
                                            <PopCheck
                                                state={group.selected}
                                                disabled={!group.enabled}
                                                label={"Usa tutto il gruppo " + group.name}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    toggleGroup(index);
                                                }}
                                            />
                                            <span className='pop-row-main'>
                                                <span className='pop-row-name'>{group.name}</span>
                                                <span className='pop-row-meta'>
                                                    {group.enabled ? countSelected(group.words) + " di " + group.words.length + " parole" : "Nessuna parola"}
                                                    {doubles > 0 && <> · {doubles} <PopX2 off={!group.selected}/></>}
                                                </span>
                                            </span>
                                            <span className='pop-round'><FlatIcon name="next" size={18}/></span>
                                        </div>
                                    );
                                })}
                            </div>
                        </PopWell>
                    ) : (
                        <PopWell className='cw-empty'>
                            <div className='cw-empty-cards' aria-hidden="true">
                                <span className='cw-card cw-card-1 pop-g-orange pop-gloss'>TRENO</span>
                                <span className='cw-card cw-card-2 pop-g-green pop-gloss'>SOLE</span>
                                <span className='cw-card cw-card-3 pop-g-blue pop-gloss'>MELA</span>
                                <span className='cw-card-plus pop-g-pink pop-gloss-sm'><FlatIcon name="plus" size={26} weight={3.6}/></span>
                            </div>
                            <p className='cw-empty-title'>Ancora nessun gruppo</p>
                            <p className='pop-txt'>Crea un gruppo con le parole che conoscete solo voi.</p>
                        </PopWell>
                    )}

                    <PopWell>
                        <span className='pop-cap'>Parole in partita</span>
                        <div className='pop-toggles'>
                            <PopToggle
                                on={useStandards}
                                onClick={() => {
                                    if((useStandards && useCustoms) || !useStandards) {
                                        setUseStandards(!useStandards);
                                    }
                                }}
                            >
                                Standard
                            </PopToggle>
                            {/* sui telefoni stretti la versione breve tiene i due interruttori sulla stessa riga */}
                            <PopToggle
                                on={useCustoms}
                                color="orange"
                                tone="#D2560A"
                                label="Personalizzate"
                                disabled={!useCustoms && !canUseCustoms()}
                                onClick={() => {
                                    if((useStandards && useCustoms) || (!useCustoms && canUseCustoms())) {
                                        setUseCustoms(!useCustoms);
                                    }
                                }}
                            >
                                <span className='pop-long'>Personalizzate</span><span className='pop-short'>Personaliz.</span>
                            </PopToggle>
                        </div>
                        {!canUseCustoms() && <span className='pop-hint'>
                            <FlatIcon name="lock" size={18} color="#D6EAFF" weight={2.6}/>
                            {hasAnyWord ? "Per usare le personalizzate spunta almeno una parola." : "Per usare le personalizzate serve almeno un gruppo con parole."}
                        </span>}
                        <div className='cw-mix'>
                            <div className='pop-range-label'>
                                <span className='cw-mix-std'>Standard <b>{stdPerc}%</b></span>
                                <span className='cw-mix-pers'><b>{100 - stdPerc}%</b> Personalizzate</span>
                            </div>
                            <PopSlider
                                variant="mix"
                                value={percent}
                                min={0}
                                max={1}
                                step={0.1}
                                disabled={!(useStandards && useCustoms)}
                                label="Percentuale di parole standard"
                                onChange={(value) => {
                                    updateSliderVal(value, setPercent);
                                }}
                            />
                        </div>
                    </PopWell>
                </Dialog>}

                {/* CREA UN NUOVO GRUPPO */}
                {showAddGroup && <Dialog
                    id="addGroup-dialog"
                    title="Crea un nuovo gruppo"
                    size="compact"
                    cancel={() => {
                        closePopup("addGroup-dialog", setShowAddGroup);
                    }}
                    confirm={addGroup}
                    canConfirm={canConfirmGroup}
                >
                    <PopWell>
                        <span className='pop-cap'>Nome del gruppo</span>
                        <Input
                            id="groupName"
                            type="text"
                            size={inputSizes["popup"]}
                            color={inputColors["default"]}
                            placeholder="Nome gruppo"
                            onChange={(event) => {
                                onInputChange(event, GROUP_NAME_MAX, setCanConfirmGroup);
                                setGroupNameLen(event.target.value.trim().length);
                            }}
                            confirm={addGroup}
                            suffix={<span className={'pop-count' + (groupNameLen > GROUP_NAME_MAX ? ' pop-count-over' : '')}>{groupNameLen}/{GROUP_NAME_MAX}</span>}
                        ></Input>
                    </PopWell>
                </Dialog>}

                {/* PAROLE DI UN GRUPPO */}
                {showGroup && customWords[curGroup] && <Dialog
                    id="wordGroup-dialog"
                    title={customWords[curGroup].name}
                    cancel={backToGroups}
                    cancelIcon="back"
                    className="guide-shell"
                    actions={[{
                        id: "addWord",
                        color: "green",
                        icon: "plus",
                        txt: "Aggiungi",
                        onClick: () => {
                            //mostra popup per aggiungere la parola
                            setIsDouble(false);
                            setShowAddWord(true);
                        },
                    }]}
                >
                    <div className='cw-bar'>
                        <span className='cw-bar-txt'>
                            {customWords[curGroup].words.length} {customWords[curGroup].words.length === 1 ? "parola" : "parole"} · {countSelected(customWords[curGroup].words)} in partita
                        </span>
                        <button type="button" className='cw-delete pop-g-red pop-gloss-sm' onClick={() => setShowDeleteGroup(true)}>
                            <FlatIcon name="trash" size={18} weight={2.6}/>
                            Elimina gruppo
                        </button>
                    </div>
                    <PopWell scroll>
                        {customWords[curGroup].words.length > 0 ? <>
                            <div className='pop-head cw-tools'>
                                <button type="button" className='cw-selall' onClick={toggleAllWords}>
                                    <PopCheck state={isGroupSelected(customWords[curGroup])}/>
                                    Seleziona tutte
                                </button>
                                <span className='cw-legend'><PopX2/> parola per il raddoppio</span>
                            </div>
                            <PopDivider/>
                            <div className='pop-rows'>
                                {customWords[curGroup].words.map((word, index) => (
                                    <div key={word.name} className={'pop-row pop-row-sm ' + (word.selected ? 'pop-row-on' : 'pop-row-off')} onClick={() => toggleWord(index)}>
                                        <PopCheck state={!!word.selected}/>
                                        <span className='pop-word'>{word.name}</span>
                                        {word.isDouble && <PopX2 off={!word.selected}/>}
                                        <button
                                            type="button"
                                            className='pop-round'
                                            aria-label={"Elimina " + word.name}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                deleteWord(index);
                                            }}
                                        >
                                            <FlatIcon name="trash" size={18} weight={2.6}/>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </> : <p className='pop-empty-txt'>Nessuna parola in questo gruppo</p>}
                    </PopWell>
                </Dialog>}

                {/* CONFERMA ELIMINAZIONE GRUPPO */}
                {showDeleteGroup && customWords[curGroup] && <Dialog
                    id="deleteGroup-dialog"
                    title="Eliminare il gruppo?"
                    icon="trash"
                    plate="red"
                    size="compact"
                    cancel={() => {
                        closePopup("deleteGroup-dialog", setShowDeleteGroup);
                    }}
                    confirm={deleteGroup}
                    canConfirm={true}
                    confirmDestructive={true}
                    confirmTxt="Elimina"
                    confirmIcon="trash"
                >
                    <PopWell>
                        <div className='pop-alert'>
                            <Icona kind="warn" size={56}/>
                            <span className='pop-txt'>Il gruppo <b>{customWords[curGroup].name}</b> e le sue {customWords[curGroup].words.length} {customWords[curGroup].words.length === 1 ? "parola" : "parole"} verranno eliminati.</span>
                        </div>
                    </PopWell>
                </Dialog>}

                {/* AGGIUNGI NUOVE PAROLE */}
                {showAddWord && customWords[curGroup] && <Dialog
                    id="addWord-dialog"
                    title="Aggiungi nuove parole"
                    subtitle={<>nel gruppo <b>{customWords[curGroup].name}</b></>}
                    common={() => {
                        closePopup("addWord-dialog", setShowAddWord);
                    }}
                    commonTxt="Fine"
                    confirm={() => {
                        addWord(setCanConfirmGroup);
                    }}
                    canConfirm={canConfirmGroup}
                    confirmTxt="Aggiungi"
                    confirmIcon="plus"
                >
                    <PopWell>
                        <span className='pop-cap'>Parola da indovinare</span>
                        <Input
                            id="newWord"
                            type="text"
                            size={inputSizes["popup"]}
                            color={inputColors["default"]}
                            placeholder="Parola"
                            onChange={(event) => {
                                onInputChange(event, WORD_MAX, setCanConfirmGroup);
                                const txt = event.target.value.trim();
                                setNewWord({ len: txt.length, spaced: txt.split(" ").length > 1 });
                            }}
                            confirm={() => {
                                addWord(setCanConfirmGroup);
                            }}
                            suffix={<span className={'pop-count' + (newWord.len > WORD_MAX ? ' pop-count-over' : '')}>{newWord.len}/{WORD_MAX}</span>}
                        ></Input>
                        <button type="button" className='cw-double' aria-pressed={isDouble} onClick={() => setIsDouble(!isDouble)}>
                            <PopCheck state={isDouble}/>
                            <span className='cw-double-txt'>
                                <span className='cw-double-label'>Parola per il raddoppio <PopX2/></span>
                                {newWord.spaced && isDouble
                                    ? <span className='cw-double-hint cw-double-auto'>Attivato da solo: contiene due parole</span>
                                    : <span className='cw-double-hint'>Le parole per il raddoppio devono contenere due parole.</span>}
                            </span>
                        </button>
                        {addedNow.length > 0 && <>
                            <PopDivider/>
                            <div className='pop-head'>
                                <span className='pop-cap'>Aggiunte ora</span>
                                <span className='pop-meta'>{addedNow.length} {addedNow.length === 1 ? "parola" : "parole"}</span>
                            </div>
                            <div className='pop-chips'>
                                {addedNow.map((w) => (
                                    <span key={w.name} className='pop-chip pop-chip-word'>{w.name}{w.isDouble && <PopX2/>}</span>
                                ))}
                            </div>
                        </>}
                    </PopWell>
                </Dialog>}

                <Title txt="Crea le squadre" />
                <div className='createTeams' style={{marginTop: 20+"px"}}>
                    <List id="teams"
                        listData={listData}
                        fixed={false}
                        interactable={true}
                        onItemClick={(index) => {
                            create(prevState => ({
                                ...prevState,
                                next: 3,
                                index: index
                            }));
                        }}
                    />
                </div>
                
                <CommonButton
                    id="addTeam"
                    txt="Aggiungi squadra"
                    color={btnColors["blue"]}
                    size={btnSizes["wide"]}
                    click={() => {
                        create(prevState => ({
                            ...prevState,
                            next: 2,
                            index: listData.count
                        }));
                    }}
                />
                <CommonButton
                    id="customWords"
                    txt="Parole personaliz."
                    color={btnColors["green"]}
                    size={btnSizes["wide"]}
                    click={() => {
                        setShowCustomWords(true);
                    }}
                />
                <CommonButton
                    id="play"
                    txt="Inizia!"
                    color={canStart ? btnColors["orange"] : btnColors["grey"]}
                    size={btnSizes["default"]}
                    click={() => {
                        if(canStart) {
                            setLoading(true);
                            //aggiungi le squadre create a myTeams
                            let list = [];
                            myTeams.forEach(e => {
                                list.push(e.name);
                            });
                            
                            listData.forEach(e => {
                                if(!listHasTeam(myTeams, e.name)) {
                                    list.push(e.name);
                                }
                            });

                            localStorage.setItem("myTeams", JSON.stringify(list));

                            //verifica quali parole devono essere utilizzate
                            //salva nel database le eventuali parole personalizzate in uso

                            /* //console.log(words);
                            //console.log(doubleWords); */
                            let w_list = [];
                            let double_list = [];
                            let w_forceStd = false;
                            let dw_forceStd = false;
                            if(useCustoms) {
                                customWords.forEach(group => {
                                    group.words.forEach(word => {
                                        if(!word.isDouble && word.selected) {
                                            w_list.push(word.name);  
                                        }
                                    });
                                });
                                //se le standard sono già incluse
                                //il force cambia solo la probabilità
                                //con cui verranno pescate le custom
                                if(w_list.length < 5) {
                                    w_forceStd = true;
                                }

                                customWords.forEach(group => {
                                    group.words.forEach(word => {
                                        if(word.isDouble && word.selected) {
                                            double_list.push(word.name);  
                                        }
                                    });
                                });
                                if(double_list.length < 2) {
                                    dw_forceStd = true;
                                }
                            }

                            /* //console.log(words);
                            //console.log(doubleWords); */

                            setCanStart(false);

                            (async () => {
                                try {
                                  await Promise.all([
                                    setValue(globalVars.code + "/useStandards", useStandards),
                                    setValue(globalVars.code + "/useCustoms", useCustoms),
                                    setValue(globalVars.code + "/w_forceStd", w_forceStd),
                                    setValue(globalVars.code + "/dw_forceStd", dw_forceStd),
                                    setValue(globalVars.code + "/percent", percent),
                                    useCustoms ? setValue(globalVars.code + "/words", JSON.stringify(w_list)) : Promise.resolve(),
                                    useCustoms ? setValue(globalVars.code + "/doubleWords", JSON.stringify(double_list)) : Promise.resolve()
                                  ]);
                              
                                  firebaseCommands.startGame.call(firebaseCommands.creator);
                                  setLoading(false);
                                } catch (errore) {
                                  setError(errcode["ERR_START_GAME"])
                                }
                              })();                              
                        }
                    }}
                />
            </div>}
            
            {/* Crea una squadra */}
            {isCreating.step==2 && <div className='createTeams' id="create-team-create" style={{opacity: 0}}>

                {showMyTeams && <Dialog
                    id="myTeams-dialog"
                    title="Le mie squadre"
                    icon="team"
                    common={() => {
                        closePopup("myTeams-dialog", setShowMyTeams);
                    }}
                    canConfirm={true}
                    confirmIcon="check"
                    confirm={async () => {
                        closePopup("myTeams-dialog", setShowMyTeams);
                        //aggiungi le squadre nel database
                        let hasChanged = false;
                        myTeams.forEach(e => {
                            if(!listHasTeam(listData, e.name) && e.selected) {
                                listData.push({
                                    name: e.name,
                                    score: 0
                                });
                                hasChanged = true;
                            }
                            //console.log(e.name, listHasTeam(listData, e.name), e.selected, e.enabled);
                            if(listHasTeam(listData, e.name) && !e.selected && e.enabled) {
                                listData.splice(index(e.name), 1);
                                hasChanged = true;
                            }
                        });
                        
                        //console.log(listData);

                        if(hasChanged) {
                            changeState(listData);

                            setLoading(true);
                            await setValue(globalVars.code+"/teams/", listData)
                            .then(() => {
                                setLoading(false);
                                create(prevState => ({
                                    ...prevState,
                                    next: 1,
                                }));
                                setCanConfirm(false);
                            }).catch((e) => {
                                setLoading(false);
                                setError(errcode["ERR_EDIT_TEAM"]);
                                //console.log(e);
                            });
                        }
                        
                        function index(name) {
                            return listData.findIndex(e => e.name == name);
                        }
                    }}
                >
                    <PopWell scroll>
                        {myTeams.length > 0 ? <div className='pop-rows'>
                            {myTeams.map((team, index) => (
                                team.enabled ? (
                                    <div
                                        key={team.name}
                                        className={'pop-row ' + (team.selected ? 'pop-row-on' : 'pop-row-off')}
                                        onClick={() => {
                                            //seleziona/deseleziona
                                            let list = myTeams.slice();
                                            list[index].selected = !list[index].selected
                                            setMyTeams(list);
                                        }}
                                    >
                                        <PopCheck state={!!team.selected}/>
                                        <span className='pop-row-main'><span className='pop-row-name'>{team.name}</span></span>
                                        <button
                                            type="button"
                                            className='pop-round'
                                            aria-label={"Elimina " + team.name}
                                            onClick={(event) => {
                                                //elimina squadra
                                                event.stopPropagation();
                                                let list = myTeams.slice();
                                                list.splice(index, 1);
                                                setMyTeams(list);
                                            }}
                                        >
                                            <FlatIcon name="trash" size={20} weight={2.6}/>
                                        </button>
                                    </div>
                                ) : (
                                    <div key={team.name} className='pop-row pop-row-empty pop-row-disabled'>
                                        <PopCheck state={true} disabled/>
                                        <span className='pop-row-main'>
                                            <span className='pop-row-name'>{team.name}</span>
                                            <span className='pop-row-meta'>Già in partita</span>
                                        </span>
                                    </div>
                                )
                            ))}
                        </div> : <p className='pop-empty-txt'>Nessuna squadra salvata</p>}
                    </PopWell>
                </Dialog>}

                <Title txt="Nuova squadra:" />
                <div style={{display: 'flex', flexGrow: 1}}></div>
                <span id="name-txt">Dai un nome alla tua squadra:</span>
                <span id="hint-txt">(dovrebbe includere un articolo)</span>
                <Input
                    id="teamName"
                    type="text"
                    size={inputSizes["default"]}
                    color={inputColors["default"]}
                    placeholder="Nome squadra"
                    onChange={(event) => {
                        onInputChange(event, 13, setCanConfirm);
                    }}
                    confirm={createTeam}
                />
                
                <CommonButton
                    id="myTeams"
                    txt="Le mie squadre"
                    color={btnColors["green"]}
                    size={btnSizes["wide"]}
                    click={() => {
                        //controlla tra le squadre aggiunte manualmente
                        //se ce n'è qualcuna salvata
                        let list = myTeams.slice();

                        list.forEach(e => {
                            e.enabled = !listHasTeam(listData, e.name) || e.selected;
                            e.selected = listHasTeam(listData, e.name) && e.enabled;
                        });

                        setShowMyTeams(true);
                    }}
                />
                <div style={{display: 'flex', flexGrow: 1}}></div>
                <CommonButton
                    id="saveTeam"
                    txt="Salva"
                    color={canConfirm ? btnColors["orange"] : btnColors["grey"]}
                    size={btnSizes["default"]}
                    click={createTeam}
                />
                <CommonButton
                    id="cancelTeam"
                    txt="Annulla"
                    color={btnColors["blue"]}
                    size={btnSizes["button"]}
                    click={() => {
                        setCanConfirm(false);
                        create(prevState => ({
                            ...prevState,
                            next: 1,
                        }));
                    }}
                />
                
            </div>}

            {/* Modifica una squadra */}
            {isCreating.step==3 && <div className='createTeams' id="create-team-edit" style={{opacity: 0}}>
                <Title txt="Modifica squadra:" />
                <div style={{display: 'flex', flexGrow: 1}}></div>
                <span id="name-txt">Nuovo nome:</span>
                <span id="hint-txt">(dovrebbe includere un articolo)</span>
                <Input
                    id="teamName"
                    type="text"
                    value={listData[isCreating.index] ? listData[isCreating.index].name : ""}
                    size={inputSizes["default"]}
                    color={inputColors["default"]}
                    placeholder="Nome squadra"
                    onChange={(event) => {
                        onInputChange(event, 13, setCanConfirm);
                    }}
                    confirm={editTeam}
                />
                
                <div style={{display: 'flex', flexGrow: 1}}></div>
                <div className='dialog-btns'>
                    <CommonButton
                        id="deleteTeam"
                        icon={<FlatIcon name="trash" size={55} weight={2.4}/>}
                        alt="Icona elimina"
                        color={btnColors["red"]}
                        size={btnSizes["mini2"]}
                        click={deleteTeam}
                    />
                    <div style={{width: 20+"px"}}></div>
                    <CommonButton
                        id="saveTeam"
                        txt="Salva"
                        color={canConfirm ? btnColors["orange"] : btnColors["grey"]}
                        size={btnSizes["default"]}
                        click={editTeam}
                    />
                </div>
                <div style={{height: 10+"px"}}></div>
                <CommonButton
                    id="cancelTeam"
                    txt="Annulla"
                    color={btnColors["blue"]}
                    size={btnSizes["button"]}
                    click={() => {
                        setCanConfirm(false);
                        create(prevState => ({
                            ...prevState,
                            next: 1,
                        }));
                    }}
                />
                
            </div>}


        </div>
    );
}

export default CreateTeams;